import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ISelfAlertCourseDatasource } from '../datasources/self_alert_course_datasource';
import { ISelfAlertReasonDatasource } from '../datasources/self_alert_reasons_datasource';
import { SelfAlertTermModel } from '../models/self_alert_term_model';

interface ITerms {
  [p: string]: Array<Record<string, string>>;
}

angular
  .module('capability-ng-priority-feed')
  .factory(
    'getSelfAlertDataCommand',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      getJwtTokenCommand: ICommand,
      appConfigModel: any,
      ngSelfAlertReasonDatasource: ISelfAlertReasonDatasource,
      ngSelfAlertCourseDatasource: ISelfAlertCourseDatasource,
      ngSelfAlertTermModel: SelfAlertTermModel
    ): ICommand => {
      return defineCommandORM('getSelfAlertDataCommand', (deferred): void => {
        const campusUrl = appConfigModel.getConfigProperty(`core-campus_url`);
        if (_4.isEmpty(campusUrl)) {
          deferred.resolve();
        } else {
          getJwtTokenCommand().then((token: any) => {
            const config = {
              url: campusUrl + '/api/v3/student_resources/alerts/form_options',
              method: 'GET',
              headers: {
                Authorization: token.access_token,
                isCampusAPI: true
              }
            };
            $http(config)
              .then(({ data }: any) => {
                const alertReasons = (data.data.alert_reasons as unknown as Array<Record<string, string>>).map(
                  (reason) => ({
                    id: _4.keys(reason)[0],
                    reason: _4.values(reason)[0] as unknown as string
                  })
                );

                ngSelfAlertReasonDatasource.clear().write(alertReasons);

                const courses = _4.flatten(_4.values(data.data.enrollments));
                const courseList = _4.map(courses, (course) => ({
                  id: _4.keys(course)[0],
                  courseName: _4.values(course)[0] as unknown as string
                }));

                ngSelfAlertCourseDatasource.clear().write(courseList);

                const enrolls: any = [];
                for (const key in data.data.enrollments as unknown as ITerms) {
                  const value = data.data.enrollments[key];
                  const courseIds = _4.map(value, (course) => _4.keys(course)[0]);
                  enrolls.push({
                    term: key,
                    courseIds
                  });
                }

                ngSelfAlertTermModel.clear().write({ enrollments: enrolls });
                deferred.resolve(data);
              })
              .catch((e: any) => {
                deferred.reject(e);
              });
          });
        }
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/commands/get_self_alert_data_command.ts